<template>
  <div>
    <Panel :title="$t('branches.title')">
      <table :class="{mobile: isMobile}">
        <thead>
          <tr>
            <th v-if="!isMobile">{{$t('user_branch.image')}}</th>
            <th class="name">
              <div class="name-holder">
                <span class="name">{{$t('user_branch.branch_name')}}</span>
                <div class="input">
                  <input type="text" v-model="filter" :placeholder="$t('user_branch.filter')">
                  <svgicon src="icon/search.svg" :height="15" :width="15"></svgicon>
                </div>
              </div>
            </th>
            <th v-if="!isMobile">{{$t('user_branch.server')}}</th>
            <th>{{$t('user_branch.actions')}}</th>
          </tr>
        </thead>
        <tbody>
        <tr v-for="branch of branches" :index="'branch-' + branch.id" @click="go(branch)">
          <td class="img" v-if="!isMobile">
            <div class="image" v-if="branch.imageUrl" :style="{backgroundImage: 'url(\'' + Parameters.urlFileServer + branch.imageUrl + '\')'}"></div>
          </td>
          <td class="name">
            {{branch.name}}
            <template v-if="isMobile">
              <div class="server">{{branch.server.name}}</div>
            </template>
          </td>
          <td v-if="!isMobile">{{branch.server.name}}</td>
          <td>
            <button class="btn btn-secondary" @click="go(branch)">
              {{$t('user_branch.view_branch')}}
              <svgicon src="icon/arrow-right.svg" :height="16" :width="16"></svgicon>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </Panel>
  </div>
</template>

<script>
  export default {
    name: "UserBranches",

    data() {
      return {
        filter: "",
        Parameters
      }
    },

    computed: {
      branches() {
        let branches = this.$store.state.loggedUser.accessibleBranches || [];
        branches.sort((b1, b2) => b1.server.name !== b2.server.name
          ? (b1.server.name < b2.server.name ? -1 : 1)
          : (b1.name < b2.name ? -1 : 1)
        );
        return branches.filter(branch => branch.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1);
      },
      isMobile() {
        return this.$mq === 'xs' || this.$mq === 'sm' || this.$mq === 'md';
      },
    },

    mounted() {
      if (!this.$store.getters.loggedUserHasDistributor) {
        this.$router.replace("/companies?branch=" + this.$store.state.loggedUser.branch);
        return;
      }
      this.$store.state.pageTitleTranslationKey = "branches.title";
      this.$store.state.pageIcon = "/icon/branches.svg";
    },

    methods: {
      go(to) {
        this.$store.commit('setContextServer', to.server);
        this.$router.push(`/companies?branch=${to.branchId}`);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .btn {
    fill: var(--primary-color);
    display: flex;
    align-items: center;
    font-size: 14px;
    padding: 10px 15px;

    .svgicon {
      margin-left: 5px;
    }
  }

  table {
    width: 100%;

    &.mobile {
      th.name {
        width: auto;

        .name-holder {
          flex-direction: column;
          align-items: flex-start;

          input {
            margin-left: 0;
            margin-top: 2px;
            width: auto;
          }
        }
      }

      td {
        white-space: initial;

        .server {
          font-weight: normal;
          font-size: 13px;
        }
      }
    }

    th.name {
      width: 100%;
      padding-bottom: 5px;

      .name-holder {
        display: flex;
        justify-content: flex-start;
        padding-left: 15px;
        align-items: center;
        width: 100%;

        input {
          padding: 5px 10px;
          font-size: 14px;
          padding-right: 30px;
          width: 300px;
          margin-left: 20px;
        }

        div.input {
          position: relative;

          .svgicon {
            position: absolute;
            opacity: 0.2;
            right: 10px;
            top: 6px;
          }
        }
      }
    }

    th {
      font-size: 14px;
      color: #808080;
      font-weight: normal;
    }

    tr:nth-child(2n) {
      td {
        background-color: #f2f3f4;
      }
    }

    tr td {
      cursor: pointer;
    }

    td {
      background-color: #f7f8f9;
      border-top: 3px solid white;
      border-bottom: 3px solid white;
      border-radius: 6px;
      white-space: nowrap;
      padding: 10px 15px;
      font-size: 15px;
    }

    td.name {
      font-weight: 500;
    }

    .image {
      height: 60px;
      width: 140px;
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
    }

    td.img {
      padding: 0;
    }
  }
</style>
